const UNIVERSAL_BRAND_NAME = 'XXXX'
const UNIVERSAL_YEAR = 'XX'
const UNIVERSAL_MODEL = 'XX'
const UNIVERSAL_VARIANT = 'XX'

export {
  UNIVERSAL_BRAND_NAME,
  UNIVERSAL_YEAR,
  UNIVERSAL_MODEL,
  UNIVERSAL_VARIANT,
}
